import {useEffect, useRef, useState} from "react";
import {WheelRefType} from "../wheel-of-jackpotbet/wheel-of-jackpotbet.component.interface";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {WheelOfJackpotbetComponent} from "../wheel-of-jackpotbet/wheel-of-jackpotbet.component";
import {WheelOfJackpotbetDialogBox} from "./boxes/wheel-of-jb-dialog/wheel-of-jackpotbet-dialog.box";
import {FlexAdaptiveSizeItemBox, FlexContainerBox, FlexFixedSizeItemBox} from "../../themes/architecture/css-helpers/flex";
import {useServices} from "../../react-hooks/use-services.hook";
import {Button} from "../../basic-ui-components/button/base/button.component";
import {PrizeValueBox} from "./boxes/prize-value/prize-value.box";
import {WinTextBox} from "./boxes/win-text/win-text.box";
import {observer} from "mobx-react";
import {SpacerBox} from "../../basic-ui-components/layout/spacer.box";
import {ContinuePlayingButtonWrapperBox} from "./boxes/continue-playing-button-wrapper.box";
import {WheelZoomInContainerBox} from "./boxes/wheel-zoom-in-container.box";

interface IWheelOfJackpotbetDialogComponentProps {
    dialogHandler: IModalDialogHandler;
    prizes: string[];
    winAmount: number;
    winningLights: boolean;
    winningConfetti: boolean;
    prizeIndex: number;
    onContinuePlaying(): void;
}

export const WheelOfJackpotbetDialogComponent: React.FC<IWheelOfJackpotbetDialogComponentProps> = observer((props) => {
    const {dialogHandler, prizes, winAmount, prizeIndex, winningLights, winningConfetti, onContinuePlaying} = props;
    const wheelRef = useRef<WheelRefType>(null);
    const [prizeRevealed, setPrizeRevealed] = useState<boolean>(false);
    const services = useServices();
    useEffect(() => {
        wheelRef.current.spinTheWheel(prizeIndex);
    }, [prizeIndex]);
    const _onContinuePlaying = () => {
        onContinuePlaying();
        dialogHandler.close();
    }
    return (
        <WheelOfJackpotbetDialogBox>
            <FlexContainerBox direction={services.mediaQuery.landscape ? "row-reverse" : "column"}>
                <FlexFixedSizeItemBox style={{position: "relative"}}>
                    {services.theme.themeCustomizer.getWheelOfJackpotbetBackground()}
                    <WheelZoomInContainerBox>
                        <WheelOfJackpotbetComponent
                            size={284}
                            prizes={prizes}
                            ref={wheelRef}
                            winningLights={winningLights}
                            winningConfetti={winningConfetti}
                            onWheelRotationEnd={() => {
                                setPrizeRevealed(true)
                            }}
                        />
                    </WheelZoomInContainerBox>
                </FlexFixedSizeItemBox>
                {/* z-index is needed otherwise the images will get precedence and will be shown above */}
                <FlexAdaptiveSizeItemBox style={{zIndex: 1}}>
                    <FlexContainerBox direction="column" justifyContent="center" alignItems={services.mediaQuery.landscape ? "flex-start" : "stretch"} style={{height: "100%"}}>
                        <SpacerBox height="4.2rem" />
                        {prizeRevealed && <>
                            <WinTextBox className="cy-jb-bets-player-notification-type">You’ve won the {prizes[prizeIndex]} prize of</WinTextBox>
                            <PrizeValueBox className="cy-jb-bets-player-notification-win-amount">{services.currency.formatMoney(winAmount)}</PrizeValueBox>
                        </>}
                        <ContinuePlayingButtonWrapperBox>
                            <Button className="cy-jb-bets-player-notification-continue-button" preset="primary" fullWidth onClick={_onContinuePlaying} disabled={!prizeRevealed}>
                                Continue Playing
                            </Button>
                        </ContinuePlayingButtonWrapperBox>
                        <SpacerBox height="1rem" />
                    </FlexContainerBox>
                </FlexAdaptiveSizeItemBox>
            </FlexContainerBox>
        </WheelOfJackpotbetDialogBox>
    );
});